import Vue from 'vue'
import App from './App.vue'
import './assets/lib/jquery/jquery.min.js'

import store from './store/store'
import VueSweetalert2 from 'vue-sweetalert2';
import router from './router'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import BaseButton from "./components/button/BaseButton";
import PrettyCheckbox from 'pretty-checkbox-vue';
import JsonExcel from "vue-json-excel"

Vue.use(require('vue-moment'));
Vue.use(PrettyCheckbox);



const options = {
  confirmButtonColor: '#042893',
  cancelButtonColor: '#ff7674',
};

Vue.component('downloadExcel', JsonExcel);
Vue.use(VueSweetalert2, options);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
//Vue.use(PerfectScrollbar);

Vue.filter('toCurrency', function (val) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "NGN"
  }).format(val)
});




Vue.config.productionTip = false

new Vue({
  router,
  BaseButton,
  store,
  render: h => h(App)
}).$mount('#app')
